import { useEffect } from 'react';
import { usePrevious } from '~/modules/common/hooks';

const useEstimatedResourceRequestDateChangeEffect = ({
  down,
  estimatedResourceRequest,
  onRequestDateRangeChange
}) => {
  const prevDown = usePrevious(down);

  useEffect(() => {
    if (prevDown && !down && onRequestDateRangeChange) {
      onRequestDateRangeChange({
        startDate: estimatedResourceRequest.startDate,
        endDate: estimatedResourceRequest.endDate
      });
    }
  }, [
    down,
    onRequestDateRangeChange,
    prevDown,
    estimatedResourceRequest.endDate,
    estimatedResourceRequest.startDate
  ]);
};

export default useEstimatedResourceRequestDateChangeEffect;
